import { Message } from "../types/conversation/message";
import { create } from "zustand";

interface ConversationMessagesState {
  messages: Message[];
  hasMore: boolean;
  nextId?: string;
  loading: boolean;
}

interface MessageStore {
  messageOfConversation: Record<string, ConversationMessagesState>;
  setMessages: (
    conversationId: string,
    messages: Message[],
    hasMore: boolean,
    nextId?: string
  ) => void;
  appendMessages: (
    conversationId: string,
    messages: Message[],
    hasMore: boolean,
    nextId?: string
  ) => void;
  setLoading: (conversationId: string, loading: boolean) => void;
  appendMessage: (conversationId: string, message: Message) => void;
}

export const messageStore = create<MessageStore>((set) => ({
  messageOfConversation: {},
  setMessages: (conversationId, messages, hasMore, nextId) =>
    set((state) => ({
      messageOfConversation: {
        ...state.messageOfConversation,
        [conversationId]: {
          messages,
          hasMore,
          nextId,
          loading: false,
        },
      },
    })),
  appendMessages: (conversationId, messages, hasMore, nextId) =>
    set((state) => {
      const prev = state.messageOfConversation[conversationId];
      return {
        messageOfConversation: {
          ...state.messageOfConversation,
          [conversationId]: {
            messages: prev ? [...prev.messages, ...messages] : messages,
            hasMore,
            nextId,
            loading: false,
          },
        },
      };
    }),
  setLoading: (conversationId, loading) =>
    set((state) => {
      const prev = state.messageOfConversation[conversationId];
      return {
        messageOfConversation: {
          ...state.messageOfConversation,
          [conversationId]: {
            ...(prev || { messages: [], hasMore: true }),
            loading,
          },
        },
      };
    }),
  appendMessage: (conversationId, message) =>
    set((state) => {
      const prev = state.messageOfConversation[conversationId];
      if (!prev) {
        return {
          messageOfConversation: {
            ...state.messageOfConversation,
            [conversationId]: {
              messages: [message],
              hasMore: true,
              nextId: undefined,
              loading: false,
            },
          },
        };
      }
      return {
        messageOfConversation: {
          ...state.messageOfConversation,
          [conversationId]: {
            ...prev,
            messages: [message, ...prev.messages],
          },
        },
      };
    }),
}));
